import React from 'react';
import { useNavigate } from 'react-router-dom';
import './Payments.css';

function PaymentError() {
  const navigate = useNavigate();

  return (
    <div className="payments-container">
      <div className="payments-card payment-result-card">
        <div className="payments-header payment-error-header">
          <h1>Błąd płatności</h1>
          <p>Płatność nie została zrealizowana</p>
        </div>
        <div className="payments-content payment-result-content">
          <div className="payment-status-icon">&#10060;</div>
          <p className="payment-result-text">
            Wystąpił błąd podczas przetwarzania płatności.
          </p>
          <p className="payment-result-subtext">
            Spróbuj ponownie lub skontaktuj się z obsługą klienta.
          </p>
          <div className="payments-action">
            <button className="btn-pay" onClick={() => navigate('/payments')}>
              Wróć do płatności
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PaymentError;
